const Skeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      {[...Array(4)].map((_, idx) => (
        <div
          key={idx}
          className="bg-cc-gray-4 h-32 w-full animate-pulse rounded-sm"
        />
      ))}
    </div>
  );
};

export default Skeleton;
